import React from 'react';
import Text from '../../components/Text.js';
import TextInput from '../../components/TextFields/TextInput.js';
import DateInput from '../../components/TextFields/DateInput.js';
import BubbleSelectBlock from '../../components/BubbleSelectBlock.js';
import Bubble from '../../components/Bubble.js';
import Grid from '@mui/material/Grid';
import i18n from '../../localization/i18n.js';
import tokens from '../../localization/tokens.js';
import * as dates from '@simplybenefits/sb-dates';

/**
 * 
 * @param {*} value 
 * @returns 
 */
function isDefined(value) {
  return value !== undefined && value !== null;
}

/**
 * @param data
 * @param errors
 * @param onChange
 * @param isDisabled
 */
function WaiveCoverage({
  data,
  errors,
  handleChange,
  isDisabled
}) {
  const styles = {
    sectionHeader: {
      marginTop: '25px'
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    medium: true,
    customStyle: styles.sectionHeader
  }, i18n.t(tokens.labels.changeRequests.waiveCoverage)), /*#__PURE__*/React.createElement(Text, {
    light: true,
    small: true
  }, i18n.t(tokens.labels.changeRequests.waiveCoverageFor)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
    first: {
      title: `${i18n.t(tokens.labels.changeRequests.myselfAndDependents)}`,
      selected: data.newData.waiveFor === 'Self-Dependents',
      field: 'waiveSelfAndDependents'
    },
    second: {
      title: `${i18n.t(tokens.labels.changeRequests.dependentsOnly)}`,
      selected: data.newData.waiveFor === 'Dependents',
      field: 'waiveDependents'
    },
    disabled: isDisabled,
    handleChange: async field => {
      if (field === 'waiveSelfAndDependents') {
        await handleChange('waiveFor', 'Self-Dependents', 'newData');
      } else {
        await handleChange('waiveFor', 'Dependents', 'newData');
      }
    }
  }), /*#__PURE__*/React.createElement(Text, {
    light: true,
    small: true
  }, i18n.t(tokens.labels.changeRequests.forTheFollowingBenefits)), /*#__PURE__*/React.createElement(BubbleSelectBlock, {
    first: {
      title: `${i18n.t(tokens.labels.changeRequests.extendedHealth)}`,
      selected: data.newData.hasWaived === 'Health',
      field: 'hasWaivedHealth'
    },
    second: {
      title: `${i18n.t(tokens.labels.changeRequests.dental)}`,
      selected: data.newData.hasWaived === 'Dental',
      field: 'hasWaivedDental'
    },
    third: {
      title: `${i18n.t(tokens.labels.changeRequests.extendedHealthCareDental)}`,
      selected: data.newData.hasWaived === 'Health-Dental',
      field: 'hasWaivedBoth'
    },
    disabled: isDisabled,
    handleChange: async field => {
      if (field === 'hasWaivedHealth') {
        await handleChange('hasWaived', 'Health', 'newData');
      } else if (field === 'hasWaivedDental') {
        await handleChange('hasWaived', 'Dental', 'newData');
      } else if (field === 'hasWaivedBoth') {
        await handleChange('hasWaived', 'Health-Dental', 'newData');
      }
    }
  }), /*#__PURE__*/React.createElement(Text, {
    body: true,
    light: true,
    customStyle: styles.sectionHeader
  }, i18n.t(tokens.labels.changeRequests.oldComparableCoverage)), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    columnSpacing: 2
  }, isDefined(data.oldData.comparableCoverageEmployer) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.changeRequests.organization),
    value: data.oldData.comparableCoverageEmployer,
    disabled: true,
    variant: "outlined",
    fullWidth: true
  })), isDefined(data.oldData.comparableCoverageCarrier) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.changeRequests.insuranceCarrier),
    value: data.oldData.comparableCoverageCarrier,
    disabled: true,
    variant: "outlined",
    fullWidth: true
  })), isDefined(data.oldData.comparableCoverageCert) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.signup.certificateNumber),
    value: data.oldData.comparableCoverageCert,
    disabled: true,
    variant: "outlined",
    fullWidth: true
  }))), /*#__PURE__*/React.createElement(Text, {
    body: true,
    light: true,
    customStyle: styles.sectionHeader
  }, i18n.t(tokens.labels.changeRequests.newComparableCoverage)), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    columnSpacing: 2
  }, isDefined(data.newData.comparableCoverageEmployer) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.changeRequests.organization),
    value: data.newData.comparableCoverageEmployer,
    onChange: event => handleChange('employer', event.target.value, 'newData'),
    error: !isDisabled && errors.employer,
    disabled: isDisabled,
    variant: "outlined",
    fullWidth: true
  })), isDefined(data.newData.comparableCoverageCarrier) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.changeRequests.insuranceCarrier),
    value: data.newData.comparableCoverageCarrier,
    onChange: event => handleChange('insuranceCarrier', event.target.value, 'newData'),
    error: !isDisabled && errors.insuranceCarrier,
    disabled: isDisabled,
    variant: "outlined",
    fullWidth: true
  })), isDefined(data.newData.comparableCoverageCert) && /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 3
  }, /*#__PURE__*/React.createElement(TextInput, {
    label: i18n.t(tokens.labels.signup.certificateNumber),
    value: data.newData.comparableCoverageCert,
    onChange: event => handleChange('cert', event.target.value, 'newData'),
    error: !isDisabled && errors.cert,
    disabled: isDisabled,
    variant: "outlined",
    fullWidth: true
  }))));
}

/**
 *
 * @param newField
 * @param oldField
 * @returns {*|string}
 * @private
 */
function _getHasWaivedFields(newField, oldField) {
  if (!newField || oldField === newField) {
    return oldField;
  }
  const fieldSplitOld = oldField.split('-');
  const fieldSplitNew = newField.split('-');
  return fieldSplitOld.filter(e => !fieldSplitNew.includes(e)).join('-');
}

/**
 *
 * @param isLegacy
 * @param newField
 * @param oldField
 * @returns {string}
 * @private
 */
function _getReinstateForLabel(isLegacy, newField, oldField) {
  // Support for old files
  if (isLegacy) {
    return newField === 'Self-Dependents' ? `${i18n.t(tokens.labels.changeRequests.myselfAndDependents)}` : `${i18n.t(tokens.labels.changeRequests.dependentsOnly)}`;
  }
  if (oldField === 'Self-Dependents' && newField === 'Dependents') {
    return `${i18n.t(tokens.labels.changeRequests.myselfOnly)}`;
  }
  if (oldField === 'Self-Dependents' && newField === 'Self-Dependents') {
    return `${i18n.t(tokens.labels.changeRequests.myselfAndDependents)}`;
  }
  if (oldField === 'Self-Dependents' && !newField) {
    return `${i18n.t(tokens.labels.changeRequests.myselfAndDependents)}`;
  }

  // All others should just be dependents
  return `${i18n.t(tokens.labels.changeRequests.dependentsOnly)}`;
}

/**
 * @param data
 * @param errors
 * @param onChange
 * @param isDisabled
 * @returns 
 */
function ReinstateCoverage({
  data,
  errors,
  handleChange,
  isDisabled
}) {
  const styles = {
    sectionHeader: {
      marginTop: '25px'
    }
  };

  // Support legacy Change Requests that od not have these values
  const isLegacy = Object.keys(data.oldData).length === 0;
  const hasWaived = isLegacy ? data.newData.hasWaived : _getHasWaivedFields(data.newData.hasWaived, data.oldData.hasWaived);
  let hasReinstatedLabel = '';
  let reinstatedForLabel = '';
  reinstatedForLabel = _getReinstateForLabel(isLegacy, data.newData.waiveFor, data.oldData.waiveFor);
  if (hasWaived === 'Health') {
    hasReinstatedLabel = `${i18n.t(tokens.labels.changeRequests.extendedHealth)}`;
  } else if (hasWaived === 'Dental') {
    hasReinstatedLabel = `${i18n.t(tokens.labels.changeRequests.dental)}`;
  } else {
    hasReinstatedLabel = `${i18n.t(tokens.labels.changeRequests.extendedHealthCareDental)}`;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Text, {
    bold: true,
    medium: true,
    customStyle: styles.sectionHeader
  }, i18n.t(tokens.labels.changeRequests.reinstateCoverage)), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    columnSpacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Text, {
    light: true,
    small: true
  }, i18n.t(tokens.labels.changeRequests.reinstatingCoverageFor)), /*#__PURE__*/React.createElement(Bubble, {
    label: reinstatedForLabel,
    isSelected: true
  }))), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row"
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(Text, {
    light: true,
    small: true
  }, i18n.t(tokens.labels.changeRequests.forTheFollowingBenefits)), /*#__PURE__*/React.createElement(Bubble, {
    label: hasReinstatedLabel,
    isSelected: true
  }))), /*#__PURE__*/React.createElement(Text, {
    light: true,
    small: true
  }, i18n.t(tokens.labels.changeRequests.reinstatingDueTo)), /*#__PURE__*/React.createElement(Grid, {
    container: true,
    direction: "row",
    columnSpacing: 2
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(DateInput, {
    label: i18n.t(tokens.labels.changeRequests.dateStart),
    value: data.newData.depCovReinstateStartDate,
    onChange: event => handleChange('depCovReinstateStartDate', event.target.value, 'newData'),
    error: !isDisabled && errors.depCovReinstateStartDate,
    disabled: isDisabled,
    variant: "outlined",
    fullWidth: true
  })), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 6
  }, /*#__PURE__*/React.createElement(DateInput, {
    label: i18n.t(tokens.labels.changeRequests.dateEnd),
    value: data.newData.depCovReinstateEndDate,
    onChange: event => handleChange('depCovReinstateEndDate', event.target.value, 'newData'),
    error: !isDisabled && errors.depCovReinstateEndDate,
    disabled: isDisabled,
    variant: "outlined",
    fullWidth: true
  }))));
}

/**
 * @param data
 * @param errors
 * @param accessData
 * @param onChange
 * @returns 
 */
function CoverageChange({
  data,
  errors,
  handleChange,
  accessData
}) {
  const styles = {
    container: {
      display: 'flex',
      flexDirection: 'column'
    }
  };

  /**
   * Always disabled for admin/members, disabled for master users if not in 'Pending', 'Incomplete', or 'Suspended' status or no write access
   */
  const isAgentCanReview = accessData.agentWriteAccess && ['PENDING AGENT REVIEW', 'INCOMPLETE', 'SUSPENDED'].includes(data.status.toUpperCase());
  const isDisabled = !accessData.isAgent || !isAgentCanReview;
  return /*#__PURE__*/React.createElement("div", {
    style: styles.container
  }, data.type === 'Waive Benefits' && /*#__PURE__*/React.createElement(WaiveCoverage, {
    data: data,
    errors: errors,
    handleChange: handleChange,
    isDisabled: isDisabled
  }), data.type === 'Reinstate Benefits' && /*#__PURE__*/React.createElement(ReinstateCoverage, {
    data: data,
    errors: errors,
    handleChange: handleChange,
    isDisabled: isDisabled
  }));
}
export default CoverageChange;